/**
 * Global Anchor Values for Absolute-Scale Choropleth Classification
 *
 * Provides the global min/max for each metric at each ADM level.
 * Used when scaleMode === 'absolute' so that colors have consistent
 * meaning regardless of which subset of data is being viewed.
 *
 * Values sourced from actual geoBoundaries + Natural Earth datasets.
 */

export const METRIC_ANCHORS = {
  population: {
    ADM0: { min: 1000,  max: 1463865525 },  // Vatican → India
    ADM1: { min: 39,    max: 241000000  },   // Hatohobei → Uttar Pradesh
    ADM2: { min: 2,     max: 32226740   },   // Kalawo County → Shanghai
    ADM3: { min: 1,     max: 19111852   },   // Silver Beach → Delhi taluk
    ADM4: { min: 1,     max: 5117019    },   // Cubillo del Campo → Abidjan-Ville
    ADM5: { min: 5,     max: 167366     },   // Aulan → Villeurbanne
  },
  population_density: {
    ADM0: { min: 0.03,  max: 26337 },       // Mongolia → Monaco
    ADM1: { min: 0.01,  max: 44000 },
    ADM2: { min: 0.01,  max: 70000 },
    ADM3: { min: 0.01,  max: 100000 },
    ADM4: { min: 0.01,  max: 120000 },
    ADM5: { min: 0.1,   max: 50000 },
  },
  gdp_total: {
    ADM0: { min: 40e6,    max: 25.5e12 },   // Tuvalu → USA
  },
  gdp_per_capita: {
    ADM0: { min: 275,     max: 240000 },     // Burundi → Monaco
  },
};
